module.exports = __webpack_public_path__ + "img/auha_logo.b0d63c67.jpg";